/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Configure, connectStateResults } from 'react-instantsearch-dom';

import type {
  SearchPanelResultsTypesProps,
  SearchPanelSelectionBoxProps,
  SearchTypes
} from '~/legacy/types';
import { bem } from '~/legacy/utils';

import SearchResult from '../SearchResult';
import IfHits from './IfHits';
import { Index } from './InstantSearch';
import SearchPanelHits from './SearchPanelHits';
import ViewMore from './ViewMore';
import MenuLink from '../MenuLink';

export const searchTypes = ({ redirectLinks, searchOptions }: SearchTypes) => {
  return [
    {
      indexId: 'footwear',
      label: 'Footwear',
      searchOptions: searchOptions?.footwear,
      title: 'Footwear',
      to: redirectLinks?.footwear,
      type: 'footwear'
    },
    {
      indexId: 'news',
      label: 'News',
      searchOptions: searchOptions?.news,
      title: 'News',
      to: redirectLinks?.news,
      type: 'news'
    },
    {
      indexId: 'clothing',
      label: 'Clothing',
      searchOptions: searchOptions?.clothing,
      title: 'Clothing',
      to: redirectLinks?.clothing,
      type: 'clothing'
    }
  ];
};

const ViewMoreButton = connectStateResults(
  ({
    searchResults,
    to,
    onClick,
    query
  }: {
    onClick: () => void;
    query?: string;
    searchResults: any;
    to: { pathname: string };
  }) => {
    const viewMoreUrl = new URL(`${window.location.origin}${to.pathname}`);
    if (query) {
      viewMoreUrl.searchParams.append('q', query);
    }

    return searchResults && searchResults.nbHits ? (
      <MenuLink
        link={viewMoreUrl.href} 
        onClick={onClick}
        title="View More"
      />
    ) : null;
  }
);

const NoResultsForType = ({
  isMediumBreakpoint,
  title
}: {
  isMediumBreakpoint: boolean;
  title: string;
}) => (
  <>
    {isMediumBreakpoint && (
      <p className="search-panel__type">{`${title} (0)`}</p>
    )}
    <p className="search-panel__no-results-per-type">0 results</p>
  </>
);

export const SearchPanelSelectionBox = ({
  displayState,
  isMediumBreakpoint,
  close,
  query,
  to,
  title,
  searchOptions,
  type,
  indexId,
  searchCondition
}: SearchPanelSelectionBoxProps) => {
  return (
    <Index indexId={indexId}>
      <Configure {...searchOptions} />
      <div
        className={bem(`search-panel__${type}`, {
          show: displayState === type
        })}
        id={type}
      >
        <IfHits condition={searchCondition}>
          <ul className="search-panel__list">
            <SearchPanelHits
              hitComponent={SearchResult}
              hitProps={{
                onClick: close,
                query: query,
                showNbResults: !isMediumBreakpoint,
                showTitle: isMediumBreakpoint,
                title,
                type: 'searchOverlay'
              }}
              notFoundComponent={() => (
                <NoResultsForType
                  isMediumBreakpoint={isMediumBreakpoint}
                  title={title}
                />
              )}
            />
            <ViewMoreButton to={to} onClick={close} query={query} />
          </ul>
        </IfHits>
      </div>
    </Index>
  );
};

const SearchPanelResultsTypes = ({
  redirectLinks,
  searchOptions,
  isLargeBreakpoint,
  isMediumBreakpoint,
  displayState,
  close,
  query,
  searchCondition
}: SearchPanelResultsTypesProps) => {
  const items = searchTypes({ redirectLinks, searchOptions });

  return (
    <>
      {items.map((item: any = {}) => {
        const { to, title, searchOptions, type, indexId } = item;

        return (
          <SearchPanelSelectionBox
            key={type}
            isLargeBreakpoint={isLargeBreakpoint}
            displayState={displayState}
            isMediumBreakpoint={isMediumBreakpoint}
            close={close}
            query={query}
            to={to}
            title={title}
            searchOptions={searchOptions}
            type={type}
            indexId={indexId}
            searchCondition={searchCondition}
          />
        );
      })}
    </>
  );
};

export default SearchPanelResultsTypes;
